module.exports = __webpack_public_path__ + "static/media/chevron-left.18fde6c9.svg";